import { render, staticRenderFns } from "./AddColor.vue?vue&type=template&id=49f70b5e&scoped=true"
import script from "./AddColor.vue?vue&type=script&lang=js"
export * from "./AddColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f70b5e",
  null
  
)

export default component.exports